import { Component, forwardRef, Input, ViewChild, ElementRef } from '@angular/core';
import { ControlValueAccessor, NG_VALUE_ACCESSOR } from '@angular/forms';

@Component({
  selector: 'app-cuit-input',
  templateUrl: './cuit-input.component.html',
  styleUrls: ['./cuit-input.component.css'],
  providers: [{
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => CuitInputComponent),
    multi: true
  }]
})
export class CuitInputComponent implements ControlValueAccessor {
  @Input() placeholder = 'XX-XXXXXXXX-X';
  @Input() inputStyle = '';
  @Input() inputClass = 'form-control';

  @ViewChild('inputEl') inputEl: ElementRef;

  private onChange: (val: string) => void = () => {};
  onTouched: () => void = () => {};

  formatCuit(raw: string): string {
    const digits = raw.replace(/\D/g, '').slice(0, 11);
    if (digits.length <= 2) return digits;
    if (digits.length <= 10) return digits.slice(0, 2) + '-' + digits.slice(2);
    return digits.slice(0, 2) + '-' + digits.slice(2, 10) + '-' + digits.slice(10);
  }

  private setInputValue(formatted: string) {
    if (this.inputEl) {
      this.inputEl.nativeElement.value = formatted;
    }
  }

  onInput(event: any) {
    const formatted = this.formatCuit(event.target.value);
    event.target.value = formatted;
    this.onChange(formatted);
  }

  onPaste(event: any) {
    event.preventDefault();
    const pasted = (event.clipboardData || (window as any).clipboardData).getData('text');
    const formatted = this.formatCuit(pasted);
    this.setInputValue(formatted);
    this.onChange(formatted);
  }

  writeValue(val: string) {
    const formatted = val ? this.formatCuit(val) : '';
    this.setInputValue(formatted);
  }

  registerOnChange(fn: any) { this.onChange = fn; }
  registerOnTouched(fn: any) { this.onTouched = fn; }
  setDisabledState(_: boolean) {}
}
